import { createCrudHandlers } from '@indutrust/shared-mock-backend';
import {
  MOCK_TECHNOLOGIES_DEMO,
  type Technology,
} from '@indutrust/shared-model';

/** Shared mutable technology catalog for the demo/MSW backend. */
export const demoTechnologyStore: Technology[] = MOCK_TECHNOLOGIES_DEMO.map(
  (technology) => ({
    ...technology,
    capabilities: [...technology.capabilities],
  })
);

/**
 * MSW handlers for `${baseUrl}/technologies/*` from
 * {@link import('../technology-api-client.service').TechnologyApiClient}.
 */
export function technologyHandlers(baseUrl: string, seed?: Technology[]) {
  const store = seed
    ? seed.map((technology) => ({
        ...technology,
        capabilities: [...technology.capabilities],
      }))
    : demoTechnologyStore;
  return createCrudHandlers<Technology>({
    url: `${baseUrl}/technologies`,
    initial: store,
    store,
  });
}
